const SAMPLE_REPORT_IMAGES = [
  'https://cdn.magicpatterns.com/uploads/33bPN27y31EFYeZsf3b4AH/Screenshot_20260210-232317.png',
  'https://cdn.magicpatterns.com/uploads/7kZK9jWsJX37sY7n5o3KT8/Screenshot_20260210-232333.png',
  'https://cdn.magicpatterns.com/uploads/ajJRRKuEb4XMLHPkeo9KSc/Screenshot_20260210-232351.png',
]

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`))
    img.src = url
  })
}

export async function downloadSampleReport(): Promise<void> {
  const { default: jsPDF } = await import('jspdf')
  const doc = new jsPDF('p', 'mm', 'a4')
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()

  const images = await Promise.all(SAMPLE_REPORT_IMAGES.map(loadImage))

  images.forEach((img, index) => {
    if (index > 0) {
      doc.addPage()
    }

    // Calculate dimensions to fit the image within the page while maintaining aspect ratio
    const imgAspect = img.width / img.height
    const pageAspect = pageWidth / pageHeight

    let drawWidth: number
    let drawHeight: number

    if (imgAspect > pageAspect) {
      // Image is wider relative to page — fit to width
      drawWidth = pageWidth
      drawHeight = pageWidth / imgAspect
    } else {
      // Image is taller relative to page — fit to height
      drawHeight = pageHeight
      drawWidth = pageHeight * imgAspect
    }

    // Center the image on the page
    const x = (pageWidth - drawWidth) / 2
    const y = (pageHeight - drawHeight) / 2

    doc.addImage(img, 'PNG', x, y, drawWidth, drawHeight)
  })

  doc.save('ToxicDetector-CaseFile-9E0F4072.pdf')
}
